import React, { useState } from "react";
import { Link } from "react-router-dom";
import MarketingNav from "@/components/marketing/MarketingNav";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    setSent(true);
    toast.success("If that email exists, a reset link is on its way.");
  };

  return (
    <div className="min-h-screen bg-[#F8F9FC]">
      <MarketingNav />
      <div className="pt-28 pb-16 px-6 lg:px-10 flex justify-center">
        <div className="w-full max-w-md">
          <p className="text-xs uppercase tracking-[0.2em] text-[#2C6BAC] font-semibold mb-3">Account recovery</p>
          <h1 className="font-display text-4xl tracking-tighter text-[#1A1A2E] mb-8">
            Reset your password.
          </h1>

          {!sent ? (
            <form onSubmit={submit} className="bg-white border border-[#E8ECF2] rounded-xl p-7 space-y-5">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
              </div>
              <Button className="w-full bg-[#2C6BAC] hover:bg-[#1A3A5C] text-white" data-testid="forgot-submit">
                Send reset link
              </Button>
              <p className="text-sm text-center text-[#555568]">
                <Link to="/login" className="text-[#2C6BAC] hover:underline">Back to login</Link>
              </p>
            </form>
          ) : (
            <div className="bg-white border border-[#E8ECF2] rounded-xl p-7 space-y-3">
              <p className="text-sm text-[#1A1A2E]">Check your inbox for next steps.</p>
              <p className="text-xs text-[#555568]">
                For security reasons we don't disclose whether an email is registered. If you don't see anything within a few minutes,
                please <Link to="/contact" className="text-[#2C6BAC] hover:underline">contact us</Link>.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
